////////////////////////////////////////////////////////////////////////////////
// WIDGETS FUNCTIONS ///////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

const LazyInitBackgroundImages = () => import(/* webpackChunkName: "LazyInitBackgroundImages" */ "../Utility/LazyInitBackgroundImages.js");
import { getSiteInfo } from '../SiteConfigs.js';
import {get_image_mime_type} from '../Utility/ImagesManager.js';

let SITE_INFO = getSiteInfo();

function load_widget(widget_id, w_container)
{
    // If Ora right col loading, and recommended widget attempting load, cancel
    if(SITE_INFO['name'] == 'politics' && widget_id == 2 && document.querySelector('#oraPlayer') ) {
        return;
    }
    
    if(typeof w_container[0] === 'undefined') {
        return;
    } else if(typeof w_container[0].loaded_dropdown_widgets === 'undefined') {
        w_container[0].loaded_dropdown_widgets = '';
    }

    w_container.addClass('overlay');

    var now_time = new Date().getTime();
    now_time = Math.floor(now_time / 100000); // Changes every 100 seconds

    $.get(
        '/widget/'+widget_id+'.json?no_cache='+now_time,
        function(widget_data) {

            // check if widget already loaded
            if( $(`div[data-widget-id="${widget_data['id']}"]`).length > 0 && $(`div[data-widget-title="${widget_data['title']}"]`).length > 0 ){
                console.log("Widget Already Loaded");
                return;
            }

            w_container.attr('data-widget-type', widget_data['type']);
            w_container.attr('data-widget-title', widget_data['title']);
            w_container.attr('data-widget-id', widget_data['id']);

            if(widget_data['type'] == 'feed')
            {
                if(widget_data['feed_info']['feed_type'] == 'json')
                {
                    if(typeof widget_data['feed_info']['jsonp_callback'] !== 'undefined')
                    {
                        // Is JSONP
                        $.ajax({
                            crossDomain: true,
                            url: widget_data['feed_info']['feed_url']+'?no_cache='+now_time,
                            dataType: 'jsonp',
                            jsonp: 'callback',
                            jsonpCallback: widget_data['feed_info']['jsonp_callback'],
                            container_ref: w_container,
                            success : function(feed_data) {
                                feed_loaded(widget_data, feed_data, this.container_ref);
                                this.container_ref.removeClass('overlay');
                            }
                        });
                    }
                    else
                    {
                        // Is JSON
                        /*$.getJSON(widget_data['feed_info']['feed_url'], function(feed_data)
            {
              feed_loaded(widget_data, feed_data, w_container);
              w_container.removeClass('overlay');
            });*/
                        $.ajax({
                            dataType: 'json',
                            url: widget_data['feed_info']['feed_url']+'?no_cache='+now_time,
                            container_ref: w_container,
                            success: function(feed_data)
                            {
                                feed_loaded(widget_data, feed_data, this.container_ref);
                                this.container_ref.removeClass('overlay');
                            }
                        });
                    }
                }
                else if(widget_data['feed_info']['feed_type'] == 'rss')
                {
                    // Is XML
                    $.ajax({
                        type: 'GET',
                        url: widget_data['feed_info']['feed_url']+'?no_cache='+now_time,
                        dataType: 'xml',
                        container_ref: w_container,
                        success : function(feed_xml) {
                            feed_loaded(widget_data, feed_xml, this.container_ref);
                            this.container_ref.removeClass('overlay');
                        }
                    });
                }
            }
            else if(widget_data['type'] == 'story_stream')
            {
                story_stream_loaded(widget_data, w_container);
                w_container.removeClass('overlay');
            }
            else if(widget_data['type'] == 'race')
            {
                // JSONP historical data
                $.ajax({
                    crossDomain: true,
                    url: 'https://www.realclearpolitics.com/epolls/json/'+widget_data['race_id']+'_historical.js?no_cache='+now_time,
                    dataType: 'jsonp',
                    jsonp: 'callback',
                    jsonpCallback: 'return_json',
                    container_ref: w_container,
                    success : function(historical_data) {

                        // Get candidates JSON
                        $.ajax({
                            dataType: 'json',
                            url: '/poll/race/'+widget_data['race_id']+'/candidates.json?no_cache='+now_time,
                            container_ref: this.container_ref,
                            success: function(candidates_data)
                            {
                                $.ajax({
                                    dataType: 'json',
                                    url: '/poll/race/'+widget_data['race_id']+'/polling_data.json?no_cache='+now_time,
                                    container_ref: this.container_ref,
                                    success: function(polling_data)
                                    {
                                        var race_title = polling_data['moduleInfo']['title'];
                                        race_loaded(widget_data, historical_data, candidates_data, this.container_ref, race_title);
                                        this.container_ref.removeClass('overlay');
                                    }
                                });
                            }
                        });

                        // Get candidates json
                        // $.getJSON('/poll/race/'+widget_data['race_id']+'/candidates.json?no_cache='+now_time, function(candidates_data)
                        // {
                        //  // Get polling data json just for race title
                        //  $.getJSON('/poll/race/'+widget_data['race_id']+'/polling_data.json?no_cache='+now_time, function(polling_data)
                        //  {
                        //    var race_title = polling_data['moduleInfo']['title'];
                        //    race_loaded(widget_data, historical_data, candidates_data, this.container_ref, race_title);
                        //    this.container_ref.removeClass('overlay');
                        //  });
                        // });
                    }
                });
            }
            else if(widget_data['type'] == 'rcp_averages')
            {
                var race_id_arr = widget_data['race_ids'].replace(/ /g, '').split(',');

                rcp_avg_w_total = race_id_arr.length;

                for(var i = 0; i < race_id_arr.length; i++)
                {
                    $.ajax({
                        dataType: 'json',
                        url: '//www.realclearpolitics.com/poll/race/'+race_id_arr[i]+'/historical_data.json?no_cache='+now_time,
                        container_ref: w_container,
                        i_ref: i,
                        success : function(historical_data) {

                            rcp_avg_w_data[this.i_ref] = historical_data;
                            rcp_avg_w_loaded(widget_data, this.container_ref);
                        }
                    });
                }
            }
            else if(widget_data['type'] == 'head_to_head')
            {
                head_to_head_loaded(widget_data, w_container);
                w_container.removeClass('overlay');
            }
            else if(widget_data['type'] == 'latest_polls')
            {
                // Get json latest polls feed
                $.ajax({
                    dataType: 'json',
                    url: widget_data['feed_info']['feed_url'],
                    container_ref: w_container,
                    success: function(latest_polls_data)
                    {
                        latest_polls_loaded(widget_data, latest_polls_data, this.container_ref);
                        this.container_ref.removeClass('overlay');
                    }
                });
            }
            else if(widget_data['type'] == 'custom')
            {
                custom_widget_loaded(widget_data, w_container);
                w_container.removeClass('overlay');
            }
        },'json');
}

function rcp_avg_w_loaded(widget_data, w_container)
{
    for(var i = 0; i < rcp_avg_w_total; i++)
    {
        if(typeof rcp_avg_w_data[i] === 'undefined') {
            return;
        }
    }
    w_container.removeClass('overlay');

    console.log('rcp_avg_w_data', rcp_avg_w_data);

    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    w_container[0].current_item_num = 0;

    var subtitle = '';
    var hide_dropdown = 'style="display:none;"';
    if(widget_data['dropdown_title'].length > 0 && widget_data['dropdown_widgets'].length > 0) {
        subtitle = '<span class="buffer">Select Poll</span>';
        hide_dropdown = '';
    }

    var widget_html = '';

    widget_html += '<div class="rec-widget-header">';
    widget_html += '<div class="rec-title"><img class="title_icon" src="/asset/img/poll-widget-icon.png" alt="Story Stream Icon" /> '+widget_data['title']+'</div>';
    widget_html += '<div class="rec-site" '+hide_dropdown+'>';
    widget_html += '<div class="name">'+subtitle+'</div>';
    if(w_container[0].loaded_dropdown_widgets != 'none') {
        widget_html += '<div class="menu"></div>';
    }
    widget_html += '<span class="rec-site-tab"></span>';
    widget_html += '<div class="rec-site-list">';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<ul>';

        for(var key_d in w_container[0].loaded_dropdown_widgets)
        {
            var d_title = '';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
            } else {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];
            }

            var d_color = '';
            var d_background_color = 'data-bcolor=""';
            if(w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
                d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
                d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
            }
            widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul> ';
    }

    widget_html += '</div>';
    widget_html += '</div>';
    widget_html += '</div>';

    var max_height_style = '';
    if(widget_data['max_height'] > 0) {
        max_height_style = 'style="max-height: '+widget_data['max_height']+'px;"';
    }
    widget_html += '<div class="rec-link-body" '+max_height_style+'>';

    // Body of Widget
    var ul_classes = '';

    if(widget_data['max_height'] > 0) {
        ul_classes += ' scroll';
    }

    widget_html += '<ul class="'+ul_classes+'">';

    for(var i=0; i < rcp_avg_w_data.length; i++)
    {
        if(i >= widget_data['item_limit']) {
            break;
        }

        var candidates = rcp_avg_w_data[i]['rcp_avg'][0]['candidate'];

        widget_html += '<li>';
        widget_html += '<div class="content_wrapper rcp_averages">';

        var this_title = rcp_avg_w_data[i]['title'];
        if(typeof rcp_avg_w_data[i]['custom_title'] !== 'undefined') {
            if(rcp_avg_w_data[i]['custom_title'].length > 2) {
                this_title = rcp_avg_w_data[i]['custom_title'];
            }
        }

        widget_html += '<div class="title"><a href="'+rcp_avg_w_data[i]['link']+'">'+this_title+'</a></div>';
        widget_html += '<div class="byline">RCP Average</div>';

        widget_html += '<ul class="candidates">';

        var highest_name = '';
        var highest_score = 0;
        var second_highest_score = 0;
        for(var j = 0; j < candidates.length; j++)
        {
            if( parseInt(candidates[j]['value'] * 10) == 0 ) {
                continue;
            }
            if(j >= 8 && rcp_avg_w_data[i]['id'] == '6730') { // Max 8 candidates for Dem Nom 2020
                break;
            }
            var c_name = '';
            if(candidates[j]['name'] != '') {
                c_name = candidates[j]['name'];
            } else {
                c_name = candidates[j]['affiliation'];
            }

            var this_score = parseInt(candidates[j]['value'] * 10);
            if(this_score > highest_score)
            {
                highest_name = c_name;
                second_highest_score = highest_score;
                highest_score = this_score;
            }
            else if(this_score > second_highest_score)
            {
                second_highest_score = this_score;
            }

            // Add 's' if appropriate
            if(highest_name.toLowerCase() == 'democrat' || highest_name.toLowerCase() == 'republican') {
                highest_name += 's';
            }

            widget_html += '<li><span class="name">'+c_name+'</span><span class="score">'+candidates[j]['value']+'</span></li>';
        }
        widget_html += '</ul>';

        var spread = highest_name+' +' + (Math.round(highest_score - second_highest_score) / 10).toFixed(1);

        widget_html += '<div class="spread"><a href="'+rcp_avg_w_data[i]['link']+'">'+spread+'</a></div>';

        widget_html += '</div>';
        widget_html += '</li>';
    }
    widget_html += '</ul>';

    if(widget_data['max_height'] > 0) {
        widget_html += '<div class="white-overlay"></div>';
    }

    widget_html += '</div>';

    w_container.html(widget_html);

    bottom_fade(w_container);

    widget_link_events(w_container);
}

function custom_widget_loaded(widget_data, w_container)
{
    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    var new_dropdown_color = '';
    var subtitle_color = '';
    if(w_container[0].loaded_dropdown_widgets == 'none') {
        new_dropdown_color = 'style="background:none;"';
    } else if(widget_data['text_color'] == '#000000') {
        subtitle_color = 'style="color:'+widget_data['text_color']+';"';
        //new_dropdown_color = 'style="background-image:url(/asset/img/grey-bg-chev.png)"';
    }

    var subtitle = '';
    if(widget_data['dropdown_title'] !== null && widget_data['dropdown_title'].length > 0) {
        subtitle = '<span class="buffer" '+subtitle_color+'>'+widget_data['dropdown_title']+'</span>';
    }

    var widget_html = '';

    widget_html += '<div class="rec-widget-header">';
    widget_html += '<div class="rec-title" style="color:'+widget_data['text_color']+';">'+widget_data['title']+'</div>';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<div class="rec-site" '+new_dropdown_color+'>';
        widget_html += '<div class="name">'+subtitle+'</div>';
        if(w_container[0].loaded_dropdown_widgets != 'none') {
            widget_html += '<div class="menu"></div>';
        }
        widget_html += '<span class="rec-site-tab"></span>';
        widget_html += '<div class="rec-site-list">';

        if(w_container[0].loaded_dropdown_widgets != 'none')
        {
            widget_html += '<ul>';

            for(var key_d in w_container[0].loaded_dropdown_widgets)
            {
                var d_title = '';
                if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                    && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                    && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                    d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
                } else {
                    d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];
                }

                var d_color = '';
                var d_background_color = 'data-bcolor=""';
                if(typeof w_container[0].loaded_dropdown_widgets[key_d]['color'] !== 'undefined' && w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
                    d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
                    d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
                }
                widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
            }

            widget_html += '</ul> ';
        }

        widget_html += '</div>';
        widget_html += '</div>';
    }

    widget_html += '</div>';

    widget_html += '<div class="rec-link-body custom_widget_body">';

    widget_html += widget_data['custom_top'];

    widget_html += '</div>';

    w_container.html(widget_html);

    recommendedSitesMenu(w_container);
    // recommendedSitesMenuHover();
    recommendedSitesMenuItems(w_container);
    widget_link_events(w_container);

    if(parseInt(widget_data['id']) == 38 && SITE_INFO['name'] == 'world') { // Countries widget
        loadCountriesMenu();
    }

    if(parseInt(widget_data['id']) == 50 && SITE_INFO['name'] == 'energy') { // States widget
        loadStatesMenu();
    }

    /**
     * Triggers an event after the widget is ready for anyone listening
     */
    processWidgetReadyEvent(widget_data);
}

function head_to_head_loaded(widget_data, w_container)
{
    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    var new_dropdown_color = '';
    var subtitle_color = '';
    if(w_container[0].loaded_dropdown_widgets == 'none') {
        new_dropdown_color = 'style="background:none;"';
    } else if(widget_data['text_color'] == '#000000') {
        subtitle_color = 'style="color:'+widget_data['text_color']+';"';
        //new_dropdown_color = 'style="background-image:url(/asset/img/grey-bg-chev.png)"';
    }

    var subtitle = '';
    if(widget_data['dropdown_title'].length > 0) {
        subtitle = '<span class="buffer" '+subtitle_color+'>'+widget_data['dropdown_title']+'</span>';
    }

    var widget_html = '';

    widget_html += '<div class="rec-widget-header">';
    widget_html += '<div class="rec-title" style="color:'+widget_data['text_color']+';"><img class="title_icon" src="/asset/img/flag-icon.png" alt="Flag Icon" />'+widget_data['title']+'</div>';
    widget_html += '<div class="rec-site" '+new_dropdown_color+'>';
    widget_html += '<div class="name">'+subtitle+'</div>';
    if(w_container[0].loaded_dropdown_widgets != 'none') {
        widget_html += '<div class="menu"></div>';
    }
    widget_html += '<span class="rec-site-tab"></span>';
    widget_html += '<div class="rec-site-list">';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<ul>';

        for(var key_d in w_container[0].loaded_dropdown_widgets)
        {
            var d_title = '';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
            } else {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];
            }

            var d_color = '';
            var d_background_color = 'data-bcolor=""';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['color'] !== 'undefined' && w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
                d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
                d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
            }
            widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul> ';
    }

    widget_html += '</div>';
    widget_html += '</div>';
    widget_html += '</div>';

    widget_html += '<div class="head_to_head_candidates">';
    widget_html += '<div class="menu">';
    widget_html += '<img src="/asset/img/grey-bg-chev.png">';
    widget_html += '</div>';
    widget_html += '<div class="names"></div>';
    widget_html += '</div>';

    if(widget_data['dropdown_races'].length > 0)
    {
        widget_html += '<div class="head_to_head_race_dropdown"><ul>';

        for(var key_d in widget_data['dropdown_races'])
        {
            var d_title = widget_data['dropdown_races'][key_d]['title'];
            var d_id = widget_data['dropdown_races'][key_d]['id'];

            widget_html += '<li class="race_dropdown_link_'+d_id+'"><span data-id="'+d_id+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul></div>';
    }

    widget_html += '<div class="rec-link-body head_to_head_body"></div>';

    w_container.html(widget_html);

    get_head_to_head_body(widget_data, w_container);

    head_to_head_menu_init();

    race_dropdown_items_init(widget_data, w_container);

    recommendedSitesMenu(w_container);
    // recommendedSitesMenuHover();
    recommendedSitesMenuItems(w_container);
    widget_link_events(w_container);

    /**
     * Triggers an event after the widget is ready for anyone listening
     */
    processWidgetReadyEvent(widget_data);
}

function head_to_head_menu_init(){
    $('.head_to_head_candidates .menu').click(function(){
        $(this).parent().parent().find('.head_to_head_race_dropdown').toggle();
    });
}

// Race dropdown menu items click
function race_dropdown_items_init(widget_data, w_container)
{
    $('.head_to_head_race_dropdown ul li span').click(
        {
            widget_data_ref:widget_data,
            container_ref:w_container
        },
        function(event)
        {
            get_head_to_head_body(event.data.widget_data_ref, event.data.container_ref, $(this).attr('data-id'));
            //$('.head_to_head_race_dropdown').toggle();
            $(this).parent().parent().parent().toggle();
        });
}

function get_head_to_head_body(widget_data, w_container, new_race_id)
{
    // JSON polling data
    var now_time = new Date().getTime();
    now_time = Math.floor(now_time / 100000); // Changes every 100 seconds

    var target_id = 0;
    if(typeof new_race_id === 'undefined') {
        target_id = widget_data['dropdown_races'][0]['id'];
    } else {
        target_id = new_race_id;
    }

    $.getJSON('/poll/race/'+target_id+'/polling_data.json?no_cache='+now_time, function(polling_data)
    {
        var body_html = '';

        if(polling_data['poll'][0]['pollster'] == 'rcp_average')
        {
            body_html += '<div class="race-wrapper">';
            body_html += '<div class="photos">';

            for(var i = 0; i < polling_data['poll'][0]['candidate'].length; i++)
            {
                if(i > 1) {
                    break;
                }
                if(i > 0) {
                    body_html += '<div class="vert-separator"></div>';
                }
                var aff = affiliation_to_abbr(polling_data['poll'][0]['candidate'][i]['affiliation'], polling_data['poll'][0]['candidate'][i]['name']);

                var c_image_source = '';

                if(is_approve_candidate(polling_data['poll'][0]['candidate'][i]['name'])) {
                    c_image_source = '/asset/img/approve.png';
                } else if(is_disapprove_candidate(polling_data['poll'][0]['candidate'][i]['name'])) {
                    c_image_source = '/asset/img/against.png';
                } else {
                    c_image_source = window.location.protocol+'//www.realclearpolitics.com/epolls/images/'+polling_data['poll'][0]['candidate'][i]['id']+'.jpg';
                }
                body_html += '<div class="candidate '+aff+'"><img class="c_photo" onerror="this.style.display = \'none\';" src="'+c_image_source+'" alt="'+polling_data['poll'][0]['candidate'][i]['name']+'" /><img class="overlay" onerror="this.style.display = \'none\';" src="/asset/img/'+aff+'-bg.png"></div>';
            }

            body_html += '</div>';
            body_html += '<div class="scores">';

            for(var i = 0; i < polling_data['poll'][0]['candidate'].length; i++)
            {
                if(i > 1) {
                    break;
                }
                var aff = affiliation_to_abbr(polling_data['poll'][0]['candidate'][i]['affiliation'], polling_data['poll'][0]['candidate'][i]['name']);
                var score = polling_data['poll'][0]['candidate'][i]['value'];

                body_html += '<div class="'+aff+'-score">'+score+'%</div>';
            }

            body_html += '</div>';
            body_html += '<div class="score-bar">';

            // Find sum of top two candidate scores (for calculating bar width)
            var score_sum = 0;
            for(var i = 0; i < polling_data['poll'][0]['candidate'].length; i++)
            {
                if(i > 1) {
                    break;
                }
                score_sum += parseFloat(polling_data['poll'][0]['candidate'][i]['value']);
            }

            for(var i = 0; i < polling_data['poll'][0]['candidate'].length; i++)
            {
                if(i > 1) {
                    break;
                }
                var aff = affiliation_to_abbr(polling_data['poll'][0]['candidate'][i]['affiliation'], polling_data['poll'][0]['candidate'][i]['name']);
                var bar_width = ( Math.floor(parseFloat(polling_data['poll'][0]['candidate'][i]['value'])) / score_sum ) * 268;

                body_html += '<div class="'+aff+'-bar" style="width:'+bar_width+'px;"></div>';
            }
            body_html += '<div class="marker"></div>';

            body_html += '</div> ';
            body_html += '</div>';

            // Also write dropdown title custom to show candidate 1 v candidate 2
            w_container.find('.head_to_head_candidates .names').html('<span class="dem">'+polling_data['poll'][0]['candidate'][0]['name']+'</span><span class="versus"> v </span><span class="gop">'+polling_data['poll'][0]['candidate'][1]['name']+'</span>');
        }

        w_container.find('.head_to_head_body').html(body_html);
    });
}

function affiliation_to_abbr(aff, name)
{
    if(aff.toLowerCase() == 'democrat') {
        return 'dem';
    } else if(aff.toLowerCase() == 'republican') {
        return 'gop';
    } else if(aff.toLowerCase() == 'independent') {
        return 'ind';
    } else if(name.toLowerCase() == 'approve'
        || name.toLowerCase() == 'right direction'
        || name.toLowerCase() == 'favorable'
        || name.toLowerCase() == 'support') {
        return 'approve';
    } else if(name.toLowerCase() == 'disapprove'
        || name.toLowerCase() == 'wrong track'
        || name.toLowerCase() == 'unfavorable'
        || name.toLowerCase() == 'oppose') {
        return 'disapprove';
    }
    else
    {
        if(name.toLowerCase() == 'approve'
            || name.toLowerCase() == 'right direction'
            || name.toLowerCase() == 'favorable'
            || name.toLowerCase() == 'support') {
            return 'approve';
        } else if(name.toLowerCase() == 'disapprove'
            || name.toLowerCase() == 'wrong track'
            || name.toLowerCase() == 'unfavorable'
            || name.toLowerCase() == 'oppose') {
            return 'disapprove';
        } else {
            return 'other';
        }
    }
}

function is_approve_candidate(name)
{
    if(name.toLowerCase() == 'approve'
        || name.toLowerCase() == 'right direction'
        || name.toLowerCase() == 'favorable'
        || name.toLowerCase() == 'support') {
        return true;
    }
    return false;
}

function is_disapprove_candidate(name)
{
    if(name.toLowerCase() == 'disapprove'
        || name.toLowerCase() == 'wrong track'
        || name.toLowerCase() == 'unfavorable'
        || name.toLowerCase() == 'oppose') {
        return true;
    }
    return false;
}

function race_loaded(widget_data, historical_data, candidates_data, w_container, race_title)
{
    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    w_container[0].current_item_num = 0;

    var subtitle = '';
    var hide_dropdown = 'style="display:none;"';
    if(widget_data['dropdown_title'].length > 0 && widget_data['dropdown_widgets'].length > 0) {
        subtitle = '<span class="buffer">Select Poll</span>';
        hide_dropdown = '';
    }

    var widget_html = '';

    widget_html += '<div class="rec-widget-header">';
    widget_html += '<div class="rec-title"><img class="title_icon" src="/asset/img/poll-widget-icon.png" alt="Story Stream Icon" /> '+widget_data['title']+'</div>';
    widget_html += '<div class="rec-site" '+hide_dropdown+'>';
    widget_html += '<div class="name">'+subtitle+'</div>';
    if(w_container[0].loaded_dropdown_widgets != 'none') {
        widget_html += '<div class="menu"></div>';
    }
    widget_html += '<span class="rec-site-tab"></span>';
    widget_html += '<div class="rec-site-list">';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<ul>';

        for(var key_d in w_container[0].loaded_dropdown_widgets)
        {
            var d_title = '';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
            } else {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];
            }

            var d_color = '';
            var d_background_color = 'data-bcolor=""';
            if(w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
                d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
                d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
            }
            widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul> ';
    }

    widget_html += '</div>';
    widget_html += '</div>';
    widget_html += '</div>';

    var max_height_style = '';
    if(widget_data['max_height'] > 0) {
        max_height_style = 'style="max-height: '+widget_data['max_height']+'px;"';
    }
    widget_html += '<div class="rec-link-body" '+max_height_style+'>';

    widget_html += get_race_widget_body(widget_data, historical_data, candidates_data, w_container, race_title);

    widget_html += '</div>';

    widget_html += '<div class="more"><a href="/stream/?topic='+widget_data['topic']+'">See the full poll</a></div>';

    w_container.html(widget_html);

    bottom_fade(w_container);

    race_date_arrows(widget_data, historical_data, candidates_data, w_container, race_title);
    widget_link_events(w_container);
}

function race_date_arrows(widget_data, historical_data, candidates_data, w_container, race_title)
{
    w_container.find('.race_nav .left_arrow').click(
        {
            widget_data_ref: widget_data,
            historical_data_ref: historical_data,
            candidates_data_ref: candidates_data,
            container_ref: w_container,
            race_title_ref: race_title
        },
        function(event)
        {
            event.data.container_ref[0].current_item_num += 1;
            var body_html = get_race_widget_body(event.data.widget_data_ref, event.data.historical_data_ref, event.data.candidates_data_ref, event.data.container_ref, event.data.race_title_ref);
            event.data.container_ref.find('.rec-link-body').html(body_html);
            race_date_arrows(event.data.widget_data_ref, event.data.historical_data_ref, event.data.candidates_data_ref, event.data.container_ref, event.data.race_title_ref);
        });
    w_container.find('.race_nav .right_arrow').click(
        {
            widget_data_ref: widget_data,
            historical_data_ref: historical_data,
            candidates_data_ref: candidates_data,
            container_ref: w_container,
            race_title_ref: race_title
        },
        function(event)
        {
            if(event.data.container_ref[0].current_item_num > 0)
            {
                event.data.container_ref[0].current_item_num -= 1;
                var body_html = get_race_widget_body(event.data.widget_data_ref, event.data.historical_data_ref, event.data.candidates_data_ref, event.data.container_ref, event.data.race_title_ref);
                event.data.container_ref.find('.rec-link-body').html(body_html);
                race_date_arrows(event.data.widget_data_ref, event.data.historical_data_ref, event.data.candidates_data_ref, event.data.container_ref, event.data.race_title_ref);
            }
        });
}

function get_race_widget_body(widget_data, historical_data, candidates_data, w_container, race_title)
{
    var body_html = '';

    //console.log(w_container[0].current_item_num);

    body_html += '<div class="race_title">'+race_title+'</div>';

    body_html += '<div class="race_nav">';

    var rcp_avg_date = new Date(historical_data['poll']['rcp_avg'][w_container[0].current_item_num]['date']);

    var month_num_to_text = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    var rcp_avg_display_date = month_num_to_text[rcp_avg_date.getMonth()]+' '+rcp_avg_date.getDate()+', '+rcp_avg_date.getFullYear();

    body_html += '<div class="left_arrow">&lt;</div>';
    body_html += '<div class="right_arrow">&gt;</div>';
    body_html += '<div class="date">'+rcp_avg_display_date+'</div>';

    body_html += '</div>';

    var ul_classes = 'race';
    if(widget_data['max_height'] > 0) {
        ul_classes += ' scroll';
    }
    body_html += '<ul class="'+ul_classes+'">';

    var race_data = historical_data['poll']['rcp_avg'][w_container[0].current_item_num];

    for(var i=0; i<race_data['candidate'].length; i++)
    {
        if(i >= widget_data['item_limit']) {
            break;
        }
        if(race_data['candidate'][i]['value'] == null || race_data['candidate'][i]['value'] == '') {
            continue;
        }
        body_html += '<li>';

        var c_color = '';
        var c_b_color = '';
        if(race_data['candidate'][i]['color'].length > 0) {
            c_color = 'color:'+race_data['candidate'][i]['color']+';';
            c_b_color = 'background-color:'+race_data['candidate'][i]['color']+';';
        }

        var c_image = '';
        for(var j=0; j<candidates_data['candidates'].length; j++)
        {
            if(candidates_data['candidates'][j]['candidate_id'] == race_data['candidate'][i]['id']) {
                if(candidates_data['candidates'][j]['candidate_image'] != '' && candidates_data['candidates'][j]['candidate_image'] != null && candidates_data['candidates'][j]['candidate_image_show'] != '0') {
                    c_image = '<img src="'+candidates_data['candidates'][j]['candidate_image']+'" alt="'+race_data['candidate'][i]['name']+'" />';
                }
            }
        }

        body_html += '<div class="dot"><div class="inner_dot" style="'+c_b_color+'"></div></div>';
        body_html += '<div class="candidate"><div class="image" style="'+c_b_color+'">'+c_image+'</div><div class="name">'+race_data['candidate'][i]['name']+'</div></div>';
        body_html += '<div class="percentage" style="'+c_color+'">'+race_data['candidate'][i]['value']+'%</div>';

        body_html += '</li>';
    }

    body_html += '</ul>';

    if(widget_data['max_height'] > 0) {
        body_html += '<div class="white-overlay"></div>';
    }

    return body_html;
}

function story_stream_loaded(widget_data, w_container)
{
    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    var w_color = '';

    if(widget_data['color'] != '') {
        w_color = 'style="background:'+widget_data['color']+';"';
    }

    var new_dropdown_color = '';
    var subtitle_color = '';
    if(w_container[0].loaded_dropdown_widgets == 'none') {
        new_dropdown_color = 'style="background:none;"';
    } else if(widget_data['text_color'] == '#000000') {
        subtitle_color = 'style="color:'+widget_data['text_color']+';"';
        //new_dropdown_color = 'style="background-image:url(/asset/img/grey-bg-chev.png)"';
    }

    var subtitle = '';
    if(widget_data['dropdown_title'].length > 0) {
        subtitle = '<span class="buffer" '+subtitle_color+'>'+widget_data['dropdown_title']+'</span>';
    }

    var widget_html = '';

    widget_html += '<div class="rec-widget-header" '+w_color+'>';
    widget_html += '<div class="rec-title" style="color:'+widget_data['text_color']+';"><img class="title_icon" src="/asset/img/stream-widget-icon.png" alt="Story Stream Icon" /> '+widget_data['title']+'</div>';
    widget_html += '<div class="rec-site" '+new_dropdown_color+'>';
    widget_html += '<div class="name">'+subtitle+'</div>';
    if(w_container[0].loaded_dropdown_widgets != 'none') {
        widget_html += '<div class="menu"></div>';
    }
    widget_html += '<span class="rec-site-tab"></span>';
    widget_html += '<div class="rec-site-list">';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<ul>';

        for(var key_d in w_container[0].loaded_dropdown_widgets)
        {
            var d_title = '';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
            } else {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];

            }

            var d_color = '';
            var d_background_color = 'data-bcolor=""';
            if(w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
                d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
                d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
            }
            widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul> ';
    }

    widget_html += '</div>';
    widget_html += '</div>';
    widget_html += '</div>';

    var max_height_style = '';
    if(widget_data['max_height'] > 0) {
        max_height_style = 'style="max-height: '+widget_data['max_height']+'px;"';
    }
    widget_html += '<div class="rec-link-body" '+max_height_style+'>';

    var ul_classes = 'items';
    if(widget_data['max_height'] > 0) {
        ul_classes += ' scroll';
    }
    if(widget_data['show_category']) {
        ul_classes += ' icons';
    }
    widget_html += '<ul class="'+ul_classes+'"></ul>';

    if(widget_data['max_height'] > 0) {
        widget_html += '<div class="white-overlay"></div>';
    }

    widget_html += '</div>';

    widget_html += '<div class="more"><a href="/stream/?topic='+widget_data['topic']+'">See full stream</a></div>';

    w_container.html(widget_html);

    bottom_fade(w_container);

    $w_ss.push($.extend(true, {}, $StoryStream)); // Clone $StoryStream object

    // By pushing a clone into an array, we are able to have multiple storystream
    // objects on a page at once, each with their own infinite scroll

    $w_ss[$w_ss.length - 1].topic = widget_data['topic'];
    $w_ss[$w_ss.length - 1].container = w_container.find('.items');
    $w_ss[$w_ss.length - 1].print_type = 'widget';
    $w_ss[$w_ss.length - 1].limit = widget_data['item_limit'];
    $w_ss[$w_ss.length - 1].ss_index = $w_ss.length - 1;

    $w_ss[$w_ss.length - 1].finished_callback = function() {

        update_date_displays();
        var $target = this.container.parent();
        $target.attr('data-ss-index', this.ss_index);
        $target.scroll(function() {
            var ss_i = parseInt($(this).attr('data-ss-index'));
            if($(this).scrollTop() + $(this).height() + 20 >= $(this)[0].scrollHeight
                && $w_ss[ss_i].scroll_continue_done == true) {
                $w_ss[ss_i].scroll_continue_done = false;
                $w_ss[ss_i].continue_stream();
            }
        });
    }

    $w_ss[$w_ss.length - 1].continue_stream();

    recommendedSitesMenu(w_container);
    // recommendedSitesMenuHover();
    recommendedSitesMenuItems(w_container);
    widget_link_events(w_container);

    /**
     * Triggers an event after the widget is ready for anyone listening
     */
    processWidgetReadyEvent(widget_data);
}

function latest_polls_loaded(widget_data, latest_polls_data, w_container)
{

    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    var new_dropdown_color = '';
    var subtitle_color = '';
    if(w_container[0].loaded_dropdown_widgets == 'none') {
        new_dropdown_color = 'style="background:none;"';
    } else if(widget_data['text_color'] == '#000000') {
        subtitle_color = 'style="color:'+widget_data['text_color']+';"';
        //new_dropdown_color = 'style="background-image:url(/asset/img/grey-bg-chev.png)"';
    }

    var subtitle = '';
    if(widget_data['dropdown_title'].length > 0 && widget_data['dropdown_widgets'].length > 0) {
        subtitle = '<span class="buffer" '+subtitle_color+'>'+widget_data['dropdown_title']+'</span>';
    }

    var title_icon = '';
    if(widget_data['show_stream_icon'] == 1) {
        title_icon = '<img class="title_icon" src="/asset/img/stream-widget-icon.png" alt="Story Stream Icon" />';
    }

    var widget_html = '';

    widget_html += '<div class="rec-widget-header">';
    widget_html += '<div class="rec-title" style="color:'+widget_data['text_color']+';">'+title_icon+widget_data['title']+'</div>';
    widget_html += '<div class="rec-site" '+new_dropdown_color+'>';
    widget_html += '<div class="name">'+subtitle+'</div>';
    if(w_container[0].loaded_dropdown_widgets != 'none') {
        widget_html += '<div class="menu"></div>';
    }
    widget_html += '<span class="rec-site-tab"></span>';
    widget_html += '<div class="rec-site-list">';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<ul>';

        for(var key_d in w_container[0].loaded_dropdown_widgets)
        {
            var d_title = '';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
            } else {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];
            }

            var d_color = '';
            var d_background_color = 'data-bcolor=""';
            /*if(w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
              d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
              d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
            }*/
            widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul> ';
    }

    widget_html += '</div>';
    widget_html += '</div>';
    widget_html += '</div>';

    var max_height_style = '';
    if(widget_data['max_height'] > 0) {
        max_height_style = 'style="max-height: '+widget_data['max_height']+'px;"';
    }
    widget_html += '<div class="rec-link-body" '+max_height_style+'>';

    var ul_classes = '';

    if(widget_data['max_height'] > 0) {
        ul_classes += ' scroll';
    }

    widget_html += '<ul class="'+ul_classes+'">';

    var lp_polls = latest_polls_data['election']['poll'];

    for(var i=0; i<lp_polls.length; i++)
    {
        if(i >= widget_data['item_limit']) {
            break;
        }

        widget_html += '<li>';
        widget_html += '<div class="content_wrapper latest_polls">';

        widget_html += '<div class="title"><a href="'+lp_polls[i]['link']+'">'+lp_polls[i]['race']+'</a></div>';
        widget_html += '<div class="byline"><a href="'+lp_polls[i]['link']+'" class="rec-auth">'+lp_polls[i]['pollster']+'</a></div>';

        widget_html += '<ul class="candidates">';
        for(var j=0; j<lp_polls[i]['candidate'].length; j++)
        {
            widget_html += '<li><a href="'+lp_polls[i]['link']+'"><span class="name">'+lp_polls[i]['candidate'][j]['name']+'</span><span class="score">'+lp_polls[i]['candidate'][j]['value']+'</span></a></li>';
        }
        widget_html += '</ul>';

        var aff_class = affiliation_to_abbr(lp_polls[i]['spread_aff'], '');

        widget_html += '<div class="spread"><a class="'+aff_class+'" href="'+lp_polls[i]['link']+'">'+lp_polls[i]['spread']+'</a></div>';

        widget_html += '</div>';
        widget_html += '</li>';
    }
    widget_html += '</ul>';

    if(widget_data['max_height'] > 0) {
        widget_html += '<div class="white-overlay"></div>';
    }


    widget_html += '</div>';

    if(widget_data['footer_text'] != '') {
        widget_html += '<div class="more"><a href="'+widget_data['footer_link']+'">'+widget_data['footer_text']+'</a></div>';
    }

    w_container.html(widget_html);

    bottom_fade(w_container);

    recommendedSitesMenu(w_container);
    // recommendedSitesMenuHover();
    recommendedSitesMenuItems(w_container);
    widget_link_events(w_container);
}

function feed_loaded(widget_data, feed_data, w_container)
{
    // Convert feed data to standard format
    var feed_standard = [];

    if($.isXMLDoc(feed_data))
    {
        // Is XML
        $(feed_data).find('item').each(function(index)
        {
            var image_url = '';
            if( widget_data['feed_info']['image'] == 'media:thumbnail' ) {
                // The comma is needed for chrome to work
                image_url = $(this).find('media\\:thumbnail, thumbnail').attr('url');
            } else if( widget_data['feed_info']['image'] == 'media:content' ) {
                // The comma is needed for chrome to work
                image_url = $(this).find('media\\:content, content').attr('url');
            } else {
                image_url = $(this).find(widget_data['feed_info']['image']).html();
            }
            var feed_item = {
                'byline' :    $(this).find(widget_data['feed_info']['byline']).html(),
                'title' :     $(this).find(widget_data['feed_info']['title_path']).html(),
                'category' :  $(this).find(widget_data['feed_info']['category']).html(),
                'image' :     image_url,
                'show_image' :  $(this).find(widget_data['feed_info']['show_image']).html(),
                'link' :    $(this).find(widget_data['feed_info']['link']).html(),
            };
            feed_standard.push(feed_item);
        });
    }
    else
    {
        // Is object (from json feed)

        for( var key1 in feed_data )
        {

            if(key1 == widget_data['feed_info']['container'])
            {
                if(typeof feed_data[key1][widget_data['feed_info']['byline']] !== 'undefined' ||
                    typeof feed_data[key1][widget_data['feed_info']['title_path']] !== 'undefined')
                {
                    var feed_item = {
                        'byline' :        feed_data[key1][widget_data['feed_info']['byline']],
                        'title':          feed_data[key1][widget_data['feed_info']['title_path']],
                        'category' :      feed_data[key1][widget_data['feed_info']['category']],
                        'image' :         feed_data[key1][widget_data['feed_info']['image']],
                        'image_webp' :    feed_data[key1][`${widget_data['feed_info']['image']}_webp`],
                        'show_image' :    feed_data[key1][widget_data['feed_info']['show_image']],
                        'link' :          feed_data[key1][widget_data['feed_info']['link']]
                    };
                    if(widget_data['show_category_color']) {
                        feed_item['category_color'] = feed_data[key1][widget_data['feed_info']['category_color']];
                    }
                    if(widget_data['feed_info']['show_image'] != '') {
                        feed_item['show_image'] = feed_data[key1][widget_data['feed_info']['show_image']];
                    }
                    if(typeof feed_data[key1]['sponsored'] !== 'undefined') {
                        feed_item['sponsored'] = feed_data[key1]['sponsored'];
                    }
                    feed_standard.push(feed_item);
                }
                else
                {
                    for( var key2 in feed_data[key1] )
                    {
                        if(typeof feed_data[key1][key2][widget_data['feed_info']['byline']] !== 'undefined' ||
                            typeof feed_data[key1][key2][widget_data['feed_info']['title_path']] !== 'undefined')
                        {
                            feed_item = {
                                'byline' :        feed_data[key1][key2][widget_data['feed_info']['byline']],
                                'title':          feed_data[key1][key2][widget_data['feed_info']['title_path']],
                                'category' :      feed_data[key1][key2][widget_data['feed_info']['category']],
                                'image' :         feed_data[key1][key2][widget_data['feed_info']['image']],
                                'image_webp' :    feed_data[key1][key2][`${widget_data['feed_info']['image']}_webp`],
                                'link' :          feed_data[key1][key2][widget_data['feed_info']['link']]
                            };
                            if(widget_data['show_category_color']) {
                                feed_item['category_color'] = feed_data[key1][key2][widget_data['feed_info']['category_color']];
                            }
                            if(widget_data['feed_info']['show_image'] != '') {
                                feed_item['show_image'] = feed_data[key1][key2][widget_data['feed_info']['show_image']];
                            }
                            if(typeof feed_data[key1][key2]['sponsored'] !== 'undefined') {
                                feed_item['sponsored'] = feed_data[key1][key2]['sponsored'];
                            }
                            feed_standard.push(feed_item);
                        }
                        else
                        {
                            for( var key3 in feed_data[key1][key2] )
                            {
                                if(typeof feed_data[key1][key2][key3][widget_data['feed_info']['byline']] !== 'undefined' ||
                                    typeof feed_data[key1][key2][key3][widget_data['feed_info']['title_path']] !== 'undefined')
                                {
                                    feed_item = {
                                        'byline' :        feed_data[key1][key2][key3][widget_data['feed_info']['byline']],
                                        'title':          feed_data[key1][key2][key3][widget_data['feed_info']['title_path']],
                                        'category' :      feed_data[key1][key2][key3][widget_data['feed_info']['category']],
                                        'image' :         feed_data[key1][key2][key3][widget_data['feed_info']['image']],
                                        'image_webp' :    feed_data[key1][key2][key3][`${widget_data['feed_info']['image']}_webp`],
                                        'link' :          feed_data[key1][key2][key3][widget_data['feed_info']['link']]
                                    };
                                    if(widget_data['show_category_color']) {
                                        feed_item['category_color'] = feed_data[key1][key2][key3][widget_data['feed_info']['category_color']];
                                    }
                                    if(widget_data['feed_info']['show_image'] != '') {
                                        feed_item['show_image'] = feed_data[key1][key2][key3][widget_data['feed_info']['show_image']];
                                    }
                                    if(typeof feed_data[key1][key2][key3]['sponsored'] !== 'undefined') {
                                        feed_item['sponsored'] = feed_data[key1][key2][key3]['sponsored'];
                                    }
                                    feed_standard.push(feed_item);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    for( var key_feed in feed_standard)
    {
        // If category is numeric, convert to our standard categories
        var cat = feed_standard[key_feed]['category'];
        if($.isNumeric(cat)) {
            cat = category_id_to_name(cat);
        }
        feed_standard[key_feed]['category'] = cat;
    }

    // Load dropdown widgets if new, else keep old dropdown info
    if(w_container[0].loaded_dropdown_widgets.length == 0)
    {
        if(widget_data['dropdown_widgets'].length > 0)
        {
            w_container[0].loaded_dropdown_widgets = widget_data['dropdown_widgets'];
            // Add self to list (will be hidden later)
            w_container[0].loaded_dropdown_widgets.unshift({
                'id' :             widget_data['id'],
                'title' :          widget_data['title'],
                'dropdown_title' : widget_data['dropdown_title'],
                'color' :          widget_data['color']
            });
        }
        else {
            w_container[0].loaded_dropdown_widgets = 'none';
        }
    }

    var w_color = '';

    if(widget_data['color'] != '') {
        w_color = 'style="background-color:'+widget_data['color']+';"';
    }

    if(widget_data['background_image'] !== null && widget_data['background_image'] !== '') {
        w_color = 'style="padding-left: 26px; background-image:url('+widget_data['background_image']+');"';
    }

    var new_dropdown_color = '';
    var subtitle_color = '';
    if(w_container[0].loaded_dropdown_widgets == 'none') {
        new_dropdown_color = 'style="background:none;display:none;"';
    } else if(widget_data['text_color'] == '#000000') {
        subtitle_color = 'style="color:'+widget_data['text_color']+';"';
        //new_dropdown_color = 'style="background-image:url(/asset/img/grey-bg-chev.png)"';
    }

    var subtitle = '';
    if(widget_data['dropdown_title'] !== null && widget_data['dropdown_title'].length > 0) {
        subtitle = '<span class="buffer" '+subtitle_color+'>'+widget_data['dropdown_title']+'</span>';
    }

    var title_icon = '';
    if(widget_data['show_stream_icon'] == 1) {
        title_icon = '<img class="title_icon" src="/asset/img/stream-widget-icon.png" alt="Story Stream Icon" />';
    }

    var widget_html = '';

    //console.log(widget_data['title']);

    widget_html += '<div class="rec-widget-header" '+w_color+'>';
    widget_html += '<div class="rec-title" style="color:'+widget_data['text_color']+';">'+title_icon+widget_data['title']+'</div>';
    widget_html += '<div class="rec-site" '+new_dropdown_color+'>';
    widget_html += '<div class="name">'+subtitle+'</div>';
    if(w_container[0].loaded_dropdown_widgets != 'none') {
        widget_html += '<div class="menu"></div>';
    }
    widget_html += '<span class="rec-site-tab"></span>';
    widget_html += '<div class="rec-site-list">';

    if(w_container[0].loaded_dropdown_widgets != 'none')
    {
        widget_html += '<ul>';

        for(var key_d in w_container[0].loaded_dropdown_widgets)
        {
            var d_title = '';
            if(typeof w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== 'undefined'
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'] !== null
                && w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'].length > 0) {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['dropdown_title'];
            } else {
                d_title = w_container[0].loaded_dropdown_widgets[key_d]['title'];
            }

            var d_color = '';
            var d_background_color = 'data-bcolor=""';
            if(w_container[0].loaded_dropdown_widgets[key_d]['color'] != '') {
                d_color = 'style="color:'+w_container[0].loaded_dropdown_widgets[key_d]['color']+';"';
                d_background_color = 'data-bcolor="'+w_container[0].loaded_dropdown_widgets[key_d]['color']+'"';
            }
            widget_html += '<li class="dropdown_link_'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'"><span '+d_color+' '+d_background_color+' data-id="'+w_container[0].loaded_dropdown_widgets[key_d]['id']+'">'+d_title+'</span></li>';
        }

        widget_html += '</ul> ';
    }

    widget_html += '</div>';
    widget_html += '</div>';
    widget_html += '</div>';

    var max_height_style = '';
    if(widget_data['max_height'] > 0) {
        max_height_style = 'style="max-height: '+widget_data['max_height']+'px;"';
    }
    widget_html += '<div class="rec-link-body" '+max_height_style+' data-id="'+widget_data['id']+'">';

    if(widget_data['show_top_pic'] == 1)
    {
        /*widget_html += '<div class="rec-image">';
      widget_html += '<a href="'+feed_standard[0]['link']+'">';
        widget_html += '<img class="centered" src="'+feed_standard[0]['image']+'" width="100%">';
        if(widget_data['show_category_label'] == '1')
        {
          widget_html += '<div class="category_label" style="background-color:'+feed_standard[0]['category_color']+';">'+feed_standard[0]['category']+'</div>';
        }
      widget_html += '</a>';
    widget_html += '</div>';*/

        // New version uses background-size: cover for cropping
        // Eventually put inline styles (except background url) in widgets css
        widget_html += '<div class="rec-image">';

        var img_url = ""; // Larger images
        var img_url_webp = "";
        if(feed_standard[0]['image'] !== null && typeof feed_standard[0]['image'] !== 'undefined'){
            img_url = feed_standard[0]['image'].replace('_1_', '_4_'); // Larger images
        }

        console.log("FEED STANDARD", feed_standard[0]);

        if(feed_standard[0]['image_webp'] !== null && typeof feed_standard[0]['image_webp'] !== 'undefined'){
            img_url_webp = feed_standard[0]['image_webp'].replace('_1_', '_4_'); // Larger images
        }

        var top_image_attrs = " ";
        top_image_attrs += `data-img-webp="${img_url_webp}" `;
        top_image_attrs += `data-img-default="${img_url}" `;

        var top_image_styles = "";
        // top_image_styles += 'background: url('+img_url+');';
        top_image_styles += 'background-size:cover;';
        //top_image_styles += 'display:block;position:absolute;top:0;right:0;bottom:0;left:0;';
        top_image_styles += 'display:block; height:100%;';

        widget_html += `<a href="${feed_standard[0]['link']}" style="${top_image_styles}" class="rc-bg" ${top_image_attrs} >`;
        if(widget_data['show_category_label'] === 1 || widget_data['show_category_label'] === '1')
        {
            widget_html += '<div class="category_label" style="background-color:'+feed_standard[0]['category_color']+';">'+feed_standard[0]['category']+'</div>';
        }
        widget_html += '</a>';
        widget_html += '</div>';
    }

    var ul_classes = '';

    if(widget_data['max_height'] > 0) {
        ul_classes += ' scroll';
    }
    if(widget_data['show_type_icons'] == 1) {
        ul_classes += ' icons';
    }

    widget_html += '<ul class="'+ul_classes+'">';

    /*console.log('widget_data');
  console.log(widget_data);
  console.log('feed_standard');
  console.log(feed_standard);*/

    for(var i=0; i<feed_standard.length; i++)
    {
        if(i >= widget_data['item_limit']) {
            break;
        }
        var li_classes = '';
        if(typeof feed_standard[i]['category'] !== 'undefined') {
            li_classes = feed_standard[i]['category'];
        }

        widget_html += '<li class="'+li_classes+'">';
        widget_html += '<div class="content_wrapper">';

        if(feed_standard[i]['category'] != 'none' && widget_data['show_category'] == '1')
        {
            var category_color = '';
            if(typeof feed_standard[i]['category_color'] !== 'undefined') {
                if(i > 0) {
                    category_color = 'style="color:'+feed_standard[i]['category_color']+';"';
                }
            }

            if( (widget_data['show_category_label'] == 0 || widget_data['show_category_label'] == '0') || i > 0) {
                widget_html += '<div class="category" '+category_color+'>'+feed_standard[i]['category']+'</div>';
            }
        }
        var widget_image_html = '';
        //if(widget_data['show_images'] == '1' && (feed_standard[i]['show_image'] == '1' || widget_data['feed_info']['show_image'] == '') )
        //console.log(widget_data['show_images']);
        //console.log(widget_data['feed_info']['show_image']);
        if(widget_data['show_images'] == '1' && widget_data['feed_info']['show_image'] != '' )
        {
            //console.log('in image html');
            var image_class = 'image';
            var center_image_class = 'img_container';
            if(widget_data['left_images'] == '1') {
                image_class += ' item_left';
            }else{
                center_image_class += ' full_width'; //used to target center class only
            }

            /**
             * In case suffix or prefix are null, make them empty strings
             * so it doesn't prepend/append null strings to image URL
             */
            if(widget_data['feed_info']['image_prefix'] == null){
                widget_data['feed_info']['image_prefix'] = "";
            }

            if(widget_data['feed_info']['image_suffix'] == null){
                widget_data['feed_info']['image_suffix'] = "";
            }

            var webp_source = '';

            if( feed_standard[i]['image_webp'] ){
                webp_source = `<source srcset="${widget_data['feed_info']['image_prefix']}${feed_standard[i]['image_webp']}${widget_data['feed_info']['image_suffix']}" type="image/webp" >`;
            }

            widget_image_html = `
            <div class="${center_image_class}">
                <a class="${image_class}" href="${feed_standard[i]['link']}">
                    <picture>
                        ${webp_source}
                        <source srcset="${widget_data['feed_info']['image_prefix']}${feed_standard[i]['image']}${widget_data['feed_info']['image_suffix']}" type="${get_image_mime_type(feed_standard[i]['image'])}">
                        <img class="content_img" onerror="this.style.display = 'none';" 
                        src="${widget_data['feed_info']['image_prefix']}${feed_standard[i]['image']}${widget_data['feed_info']['image_suffix']}" 
                        alt="${feed_standard[i]['title']}">
                    </picture>
                </a>
            </div>`;
        }

        if(widget_data['left_images'] == '1') {
            widget_html += widget_image_html;
        }

        var title_class = 'title';
        if(widget_data['left_images'] == '1') {
            title_class += ' item_left';
        }
        var sponsored_content = '';
        if(feed_standard[i]['sponsored'] == '1') {
            sponsored_content = '<div class="sponsored">Sponsored</div>';
        }
        widget_html += '<div class="'+title_class+'">'+sponsored_content+'<a href="'+feed_standard[i]['link']+'">'+feed_standard[i]['title']+'</a></div>';
        if(widget_data['show_byline'] == '1')
        {
            var byline_class = 'byline';
            if(widget_data['left_images'] == '1') {
                byline_class += ' item_left';
            }
            widget_html += '<div class="'+byline_class+'"><a href="'+feed_standard[i]['link']+'" class="rec-auth">'+feed_standard[i]['byline']+'</a></div>';
        }

        if(widget_data['left_images'] != '1') {
            widget_html += widget_image_html;
        }

        widget_html += '</div>';
        widget_html += '</li>';
    }
    widget_html += '</ul>';

    if(widget_data['max_height'] > 0) {
        widget_html += '<div class="white-overlay"></div>';
    }


    widget_html += '</div>';

    if(widget_data['footer_text'] !== null && widget_data['footer_text'].length > 0) {
        widget_html += '<div class="more"><a href="'+widget_data['footer_link']+'">'+widget_data['footer_text']+'</a></div>';
    }

    w_container.html(widget_html);

    bottom_fade(w_container);

    recommendedSitesMenu(w_container);
    // recommendedSitesMenuHover();
    recommendedSitesMenuItems(w_container);
    widget_link_events(w_container);

    LazyInitBackgroundImages()
    .then(module => {
        module.default();
    });

    /**
     * Triggers an event after the widget is ready for anyone listening
     */
    processWidgetReadyEvent(widget_data);
}

/**
 * Prep the data node element and event name to trigger
 */
function processWidgetReadyEvent(widget_data){

    var eventName       = Utils.make_slug(widget_data['title']+'_widget_ready');
    var widgetSelector  = '[data-widget-title="'+widget_data['title']+'"]';
    var htmlNode        = document.querySelector(widgetSelector);
    // console.log("TRIGGERING EVENT", eventName, widgetSelector, htmlNode);
    if( htmlNode ){
        triggerWidgetReadyEvent(htmlNode, eventName);
    }else{
        console.error("WIDGET EVENT CANNOT FIND HTML NODE", eventName, widgetSelector, htmlNode);
    }
}

/**
 * When a widget is finished loading, trigger this event to anyone listening
 */
function triggerWidgetReadyEvent(el, type){

    if ('createEvent' in document) {
        // modern browsers, IE9+
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        document.dispatchEvent(e);
    } else {
        // IE 8
        var e = document.createEventObject();
        e.eventType = type;
        document.fireEvent('on'+e.eventType, e);
    }
}

function bottom_fade(w_container)
{
    w_container.find('.rec-link-body').scroll(function()
    {
        $(this).find('.white-overlay').css('bottom', $(this).scrollTop() * -1);
    });
}

// Event when link in body of system widget is clicked
function widget_link_events(w_container)
{
    w_container.find('.rec-link-body a').click(
        {
            container_ref: w_container
        },
        function(event)
        {
            //Get the href value. Will use at the end to go to link target.
            event = event || window.event;

            var href = $(this).closest('a').attr('href');
            //Build the params to go to event tracking
            /*var ge_action = 'Section Redesign: ' + $('body').attr('class').split(' ')[0]; // Section: <first body class>
    var ge_category = 'System Widget: ' + event.data.container_ref.attr('data-widget-type') + ': ' + event.data.container_ref.attr('data-widget-title'); // System Widgets: <widget title url friendly>
    var ge_label = 'Link';*/

            var ge_action = 'Click: Link';
            var ge_category = 'System Widget Interaction';
            var ge_label = event.data.container_ref.attr('data-widget-title')+': '+$('body').attr('class').split(' ')[0];

            //Wrap event tracking call to prevent premature termination of this function.
            try{
                _gaq.push(['_trackEvent', ge_category, ge_action, ge_label]);
                console.log('trackevent: '+ge_category+' '+ge_action+' '+ge_label);
            } catch(err) {}
            if(event.ctrlKey || event.metaKey) { //If right-click or control click
                return true;
            } else {
                window.setTimeout('document.location = "' + href + '"', 100); //Go to hyperlink
                return false;
            }
        });
}

// Menu items click
function recommendedSitesMenuItems(w_container)
{
    w_container.find('.rec-site-list ul li span').click({container_ref: w_container}, function(event){
            /*var ge_action = 'Section Redesign: ' + $('body').attr('class').split(' ')[0]; // Section: <first body class>
    var ge_category = 'System Widget: ' + event.data.container_ref.attr('data-widget-type') + ': ' + event.data.container_ref.attr('data-widget-title'); // System Widgets: <widget title url friendly>
    var ge_label = 'Menu: ' + $(this).html();*/

        var ge_action = 'Click: Menu';
        var ge_category = 'System Widget Interaction';
        var ge_label = event.data.container_ref.attr('data-widget-title')+': '+$('body').attr('class').split(' ')[0];

        console.log('trackevent: '+ge_category+' '+ge_action+' '+ge_label);

        _gaq.push(['_trackEvent', ge_category, ge_action, ge_label]);

        // console.log("track event functioin: ", load_widget, "data id", $(this).attr('data-id'), "element", event.data.container_ref);
        load_widget($(this).attr('data-id'), event.data.container_ref);
    });
}

//other sites menu - recommended widget drop down menu
function recommendedSitesMenu(w_container){
    //console.log('recommendedSitesMenu');
    w_container.find('.rec-site .menu').click(
        {
            container_ref: w_container
        },
        function(event){
            event.data.container_ref.find('.rec-site-tab').toggle();
            event.data.container_ref.find('.rec-site-list').toggle();
        });
}

//open sitesMenu hover handler - changes color of pointer triangle at top of menu to match hovered site
// Now also handles color of li->a background
// function recommendedSitesMenuHover()
// {
//     $('.rec-site-list ul li span').hover(function(){

//         var bg = $(this).attr('data-bcolor');
//         if(bg.length > 0) {
//             $(this).css('color', '#ffffff');
//         }
//         $(this).css('background-color', bg);

//         $(this).parent().parent().parent().parent().find('.rec-site-tab').css( { "border-bottom" : "10px solid " + bg } );

//     }, function(){

//         var bg = $(this).attr('data-bcolor');
//         var new_color = '';
//         if(bg.length > 0) {
//             new_color = bg;
//         }
//         $(this).css('color', new_color);
//         $(this).css('background-color', '');
//         //$('.verticals-tab').css( { "border-bottom" : "10px solid #EBEBEB" } );
//         $(this).parent().parent().parent().parent().find('.rec-site-tab').css( { "border-bottom" : "10px solid #EBEBEB" } );
//     });
// }

function category_id_to_name(cat_id)
{
    if(cat_id == '0') {
        return 'none';
    } else if(cat_id == '1') {
        return 'article';
    } else if(cat_id == '2') {
        return 'video';
    } else if(cat_id == '3') {
        return 'list';
    } else if(cat_id == '4') {
        return 'poll';
    } else if(cat_id == '5') {
        return 'podcast';
    }else if(cat_id == '6'){
        return 'quiz';
    }else if(cat_id == '7'){
        return 'tag';
    }

}

function update_date_displays()
{
    $('.item_date').each(function()
    {
        var today_date = new Date();
        //var today_date = new Date(1435536200000);
        var item_date = new Date(parseInt($(this).attr('data-ms')));
        var elapsed_ms = today_date.getTime() - item_date.getTime();

        var elapsed_seconds = elapsed_ms / 1000;
        var elapsed_minutes = elapsed_ms / 60000;
        var elapsed_hours = elapsed_minutes / 60;

        var elapsed_hours_exact = Math.floor(elapsed_hours);
        var elapsed_minutes_exact = Math.floor(elapsed_minutes);
        var elapsed_seconds_exact = Math.floor(elapsed_seconds);

        var display_date = '';

        if(elapsed_hours >= 24) {
            display_date = item_date.toDateString();
        } else if(elapsed_hours >= 1) {
            display_date = elapsed_hours_exact+' hours ago';
        } else if(elapsed_minutes >= 1) {
            display_date = elapsed_minutes_exact+' min ago';
        } else if(elapsed_seconds >= 1) {
            display_date = elapsed_seconds_exact+' sec ago';
        } else {
            display_date = 'now';
        }

        $(this).html(display_date);
    })
}

export default load_widget;